export default class AnchoredScrollSection {

    constructor() {
        this.bindUIActions();
    }

    bindUIActions() {

        window.addEventListener('DOMContentLoaded', () => {

            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    const id = entry.target.getAttribute('id');
                    if (entry.intersectionRatio > 0) {
                        $(`.js-anchored-scroll-nav li a[href="#${id}"]`).parent().addClass('active');
                    } else {
                        $(`.js-anchored-scroll-nav li a[href="#${id}"]`).parent().removeClass('active');
                    }
                });
            });

            const navHeight = $('.js-anchored-scroll-nav').outerHeight();

            // Track all sections that have a `id` applied
            document.querySelectorAll('.js-anchored-scroll section[id]').forEach((section) => {
                section.style.minHeight = navHeight+'px';
                observer.observe(section);
            });

        });

        const $card = $('.js-as-card');

        if($(window).width() > 1024) {
            $card.on('mouseover', (e) => {
                const $this = $(e.currentTarget);
                const content = $this.find('.js-as-card-content');
                const link = $this.find('.js-as-card-link');
                if(link.length) {
                    content.addClass('hidden');
                    link.removeClass('hidden');
                }
            });

            $card.on('mouseleave', (e) => {
                const $this = $(e.currentTarget);
                const content = $this.find('.js-as-card-content');
                const link = $this.find('.js-as-card-link');

                if(link.length) {
                    content.removeClass('hidden');
                    link.addClass('hidden');
                }
            });
        } else {
            $card.on('tap click', (e) => {
                const $this = $(e.currentTarget);
                const content = $this.find('.js-as-card-content');
                const link = $this.find('.js-as-card-link');
                const bgColor = $this.data('bg');

                if(link.length) {
                    link.css('height', $this.height()+'px');
                    link.addClass('bg-'+bgColor);
                    content.toggleClass('hidden');
                    link.toggleClass('hidden');
                }
            });
        }

    }

};

new AnchoredScrollSection();